import React, { useState, useEffect, useCallback, useRef } from "react";
import Header from "../../components/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SuccessNotification from "../../components/Notifications/SuccessNotification";
import ErrorNotification from "../../components/Notifications/ErrorNotification";
import LoginNotification from "../../components/Notifications/LoginNotification";
import AddModulePack from "../../components/AddModulePack";
import {
  faEdit,
  faTrashAlt,
  faSearch,
  faRectangleList,
  faCircleCheck,
  faCircleXmark,
  faEye,
  faFolderPlus,
  faEllipsisH,
  faCircleArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import Table from "../../components/Table";
import Section from "../../components/Section";
import apiClient from "../../axios";
import SlideModal from "../../components/SlideModal";
import DeleteModal from "../../components/DeleteModal";
import { Tooltip } from "react-tooltip";
import { useNavigate } from "react-router-dom";
import useEscapeKey from "../../hooks/useEscapeKey";

const ProductTypeList = ({ handleLogout }) => {
  const [data, setData] = useState([]);
  //const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const itemsPerPage = 10;
  const [isSuccessVisible, setIsSuccessVisible] = useState(false);
  const [isErrorVisible, setIsErrorVisible] = useState(false);
  const [isInfoVisible, setIsInfoVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItemToggle, setSelectedItemToggle] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [contractType, setContractType] = useState([]);
  const [module, setModule] = useState([]);
  const [addModulePack, setAddModulePack] = useState(false);
  const [deleteItem, setDeleteItem] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isClickInsideDropdown = dropdownRef.current?.contains(event.target);
      const isDropdownItem = event.target.closest(".dm-class");

      if (!isClickInsideDropdown && !isDropdownItem) {
        setOpenDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEscapeKey(() => setIsModalOpen(false));

  const hasPermission = (permission) => {
    const permissions = JSON.parse(localStorage.getItem("permissions")) || [];
    return permissions.includes(permission);
  };

  const toggleModal = async (item) => {
    if (!isModalOpen) {
      try {
        const response = await apiClient.get(`/product_type/${item.id}`);
        const productData = response.data;
        const connection = {
          general: item,
          alternative: response.data,
        };
        setSelectedItemToggle(connection);

        const modId = productData.mainModuleTemplateId;

        if (modId) {
          try {
            setLoading(true);
            const modulePackResponse = await apiClient.get(
              `/module_pack/product/${item.id}`
            );
            if (modulePackResponse.status === 200) {
              setModule(modulePackResponse.data || []);
            }
          } catch (error) {
            console.error(
              "Error al cargar los módulos principales asociados",
              error
            );
          } finally {
            setLoading(false);
          }
        }
        setIsModalOpen(true);
      } catch (error) {
        setIsErrorVisible(true);
        if (error.response && error.response.status === 401) {
          setIsInfoVisible(true);
        }
      } finally {
        setIsSuccessVisible(true);
      }
    } else {
      setIsModalOpen(false);
    }
  };

  const fetchAllData = useCallback(async (page = 1) => {
    try {
      setLoading(true);
      const response = await apiClient.get(`/product_type?page=${page}`);
      if (Array.isArray(response.data.results)) {
        setData(response.data.results);
        setTotalItems(response.data.total);
      } else {
        setData([response.data.results]);
        setTotalItems(1);
      }
    } catch (error) {
      setIsErrorVisible(true);
      if (error.response && error.response.status === 401) {
        setIsInfoVisible(true);
      }
    } finally {
      setIsSuccessVisible(true);
      setLoading(false);
    }
  }, [])

  useEffect(() => {
    fetchAllData(currentPage);
    const fetchContractTypes = async () => {
      try {
        setLoading(true);
        const contTypes = await apiClient.get(`/contract_type`);
        if (contTypes.status === 200) {
          setContractType(contTypes.data || []);
        }
      } catch (error) {
        console.error("Error al cargar los Tipos de Contrato", error);
      } finally {
        setLoading(false);
      }
    };
    fetchContractTypes();
  }, [fetchAllData, currentPage]);

  const handleRefresh = () => {
    fetchAllData(currentPage);
  };

  const handleSearch = useCallback(
    async (page = 1) => {
      try {
        const params = new URLSearchParams();
        if (searchTerm) params.append("search", searchTerm);

        const response = await apiClient.get(
          `/product_type?${params.toString()}&page=${page}`
        );

        if (Array.isArray(response.data.results)) {
          setData(response.data.results);
        } else {
          setData([response.data.results]);
        }
        setTotalItems(response.data.total);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          setIsInfoVisible(true);
        }
      }
    },
    [searchTerm]
  );
  const handleFresh = async () => {
    //handleSearch(1);
    setCurrentPage(1);
    setSearchTerm(searchInput.trim());
  };

  useEffect(() => {
    if (searchTerm) {
      handleSearch(currentPage);
    } else {
      fetchAllData(currentPage);
    }

  }, [fetchAllData, handleSearch, searchTerm, currentPage]);

  const handleDeleteModal = (item) => {
    setSelectedDeleteItem(item);
    setDeleteItem(true);
  };
  const handleCloseDeleteModal = () => {
    setDeleteItem(false);
    setSelectedDeleteItem(null);
    handleRefresh();
  };

  const handleModulePack = (item) => {
    setSelectedItem(item);
    setAddModulePack(true);
  };
  const handleCloseModulePack = () => {
    setSelectedItem(null);
    handleRefresh();
  };

  const handleClick = () => {
    navigate(`/Management`);
  };

  const columns = [
    { title: "Id", key: "id" },
    { title: "Código", key: "code" },
    { title: "Descripción", key: "description" },
    { title: "Estado", key: "flagActive" },
    { title: "Acciones", key: "acciones" },
  ];

  const renderRow = (item, index) => (
    <>
      <td>{item.id}</td>
      <td>{item.code}</td>
      <td>{item.description}</td>
      <td>
        {item.flagActive ? (
          <button className="status_button">
            <FontAwesomeIcon
              icon={faCircleCheck}
              style={{ color: "green", fontSize: "24px" }}
            />
          </button>
        ) : (
          <button className="status_button">
            <FontAwesomeIcon
              className="status_icon"
              icon={faCircleXmark}
              style={{ color: "red", fontSize: "24px" }}
            />
          </button>
        )}
      </td>
      <td>
        <div className="button-container">
          <div className="desktop-buttons">
            <Tooltip id="contract-tooltip" className="custom-tooltip" />
            {hasPermission("PRODUCT_TYPE_VIEW") && (
              <button
                className="icon-button company-button"
                onClick={() => toggleModal(item)}
                data-tooltip-id="contract-tooltip"
                data-tooltip-content="Detalle"
              >
                <FontAwesomeIcon icon={faEye} />
              </button>
            )}
            <Tooltip id="edit-tooltip" className="custom-tooltip" />
            {hasPermission("PRODUCT_TYPE_UPDATE") && (
              <button
                data-tooltip-id="edit-tooltip"
                className="icon-button edit-button"
                data-tooltip-content="Editar"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/ProductTypeForm/${item.id}`);
                }}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            )}
            <Tooltip id="delete-tooltip" className="custom-tooltip" />
            {hasPermission("PRODUCT_TYPE_DELETE") && (
              <button
                data-tooltip-id="delete-tooltip"
                data-tooltip-content="Eliminar"
                className="icon-button delete-button"
                onClick={() => handleDeleteModal(item)}
                //onClick={() => handleDelete(item.id)}
              >
                <FontAwesomeIcon icon={faTrashAlt} />
              </button>
            )}
            <Tooltip id="contract-tooltip" className="custom-tooltip" />
            {hasPermission("PRODUCT_TYPE_UPDATE") && (
              <button
                className="icon-button company-button"
                data-tooltip-id="contract-tooltip"
                data-tooltip-content="Designación de módulo"
                onClick={() => handleModulePack(item)}
              >
                <FontAwesomeIcon icon={faFolderPlus} />
              </button>
            )}
          </div>

          <div className="mobile-dropdown">
            <div className="dropdown-container-contract">
              <button
                className="icon-button dropdown-button-contract"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenDropdown(openDropdown === item.id ? null : item.id);
                }}
              >
                <FontAwesomeIcon icon={faEllipsisH} />
              </button>
              {openDropdown === item.id && (
                <div className="dropdown-menu-contract dm-class">
                  {hasPermission("PRODUCT_TYPE_VIEW") && (
                    <button
                      className="dropdown-item-contract"
                      onClick={() => {
                        toggleModal(item);
                        setOpenDropdown(false);}}>
                      Detalle
                    </button>
                  )}
                  {hasPermission("PRODUCT_TYPE_UPDATE") && (
                    <button
                      className="dropdown-item-contract"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/ProductTypeForm/${item.id}`);
                      }}
                    >
                      Editar
                    </button>
                  )}
                  {hasPermission("PRODUCT_TYPE_DELETE") && (
                    <button
                      className="dropdown-item-contract"
                      onClick={() => {
                        handleDeleteModal(item);
                        setOpenDropdown(false);
                      }}
                    >
                      Eliminar
                    </button>
                  )}
                  {hasPermission("PRODUCT_TYPE_UPDATE") && (
                    <button
                      className="dropdown-item-contract"
                      onClick={() => {
                        handleModulePack(item);
                        setOpenDropdown(false);}}>
                      Designación de módulo
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </td>
    </>
  );

  return (
    <div className="home-container">
      <Header onLogout={handleLogout} title="Tipos de Productos" />
      <div className="home-content">
        <Section>
          <div className="button-return-container">
            <div className="contener-return">
              <FontAwesomeIcon
                className="basic-shortcut-icon"
                style={{ cursor: "pointer" }}
                icon={faCircleArrowLeft}
                onClick={handleClick}
              />
            </div>
            <div className="filter-form">
              <div className="basic-info-form-group">
                <input
                  type="text"
                  id="product-type"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  placeholder="Tipo de Producto"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleFresh();
                    }
                  }}
                />
              </div>
              <button className="basic-custom-button" onClick={handleFresh}>
                <FontAwesomeIcon
                  icon={faSearch}
                  className="basic-shortcut-icon"
                />
                Buscar
              </button>
            </div>
          </div>

          <div className="button-add">
            {hasPermission("PRODUCT_TYPE_CREATE") && (
              <button
                className="basic-custom-button"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate("/ProductTypeForm");
                }}
              >
                <FontAwesomeIcon
                  className="basic-shortcut-icon"
                  icon={faRectangleList}
                />
                Crear Nuevo Tipo de Producto
              </button>
            )}
          </div>
        </Section>
        <Table
          title="Lista de Tipos de Productos"
          rows={data}
          columns={columns}
          icon={faRectangleList}
          renderRow={renderRow}
          currentPage={currentPage}
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          onPageChange={setCurrentPage}
          onRefresh={handleRefresh}
          loading={loading}
          flagPagination={true}
        />
        <SuccessNotification
          message={"Se ha cargado correctamente"}
          isVisible={isSuccessVisible}
          onClose={() => setIsSuccessVisible(false)}
        />
        <ErrorNotification
          message="Ups! Ocurrio un Problema"
          isVisible={isErrorVisible}
          onClose={() => setIsErrorVisible(false)}
        />
        <LoginNotification
          message="Vuelve a iniciar sesión"
          isVisible={isInfoVisible}
          onClose={() => setIsInfoVisible(false)}
          onLogout={handleLogout}
        />
        {selectedItem && (
          <AddModulePack
            isVisible={addModulePack}
            onClose={handleCloseModulePack}
            element={selectedItem}
          />
        )}
        {selectedDeleteItem && (
          <DeleteModal
            isVisible={deleteItem}
            onClose={handleCloseDeleteModal}
            identificator={selectedDeleteItem.id}
            url={`/product_type`}
          />
        )}
        <SlideModal
          isOpen={isModalOpen}
          onClose={toggleModal}
          title="Detalles del Tipo de Producto"
        >
          <div className="section-container-form">
            <h4 className="section-title-form">ID</h4>
            <hr className="section-divider-form" />
            <div className="form-group-form">
              <label>{selectedItemToggle?.general.id}</label>
            </div>

            <h4 className="section-title-form">CÓDIGO</h4>
            <hr className="section-divider-form" />
            <div className="form-group-form">
              <label>{selectedItemToggle?.alternative.code}</label>
            </div>

            <h4 className="section-title-form">DESCRIPCIÓN</h4>
            <hr className="section-divider-form" />
            <div className="form-group-form">
              <label>{selectedItemToggle?.alternative.description}</label>
            </div>

            <h4 className="section-title-form">TIPO DE CONTRATO</h4>
            <hr className="section-divider-form" />
            <div className="form-group-form">
              <label>
                {contractType.find(
                  (cType) =>
                    cType.id === selectedItemToggle?.alternative.contractTypeId
                )?.description || "No encontrado"}
              </label>
            </div>

            <h4 className="section-title-form">MÓDULO PRINCIPAL</h4>
            <hr className="section-divider-form" />
            <div className="form-group-form">
              <label>
                {module.find(
                  (modP) =>
                    modP.id ===
                    selectedItemToggle?.alternative.mainModuleTemplateId
                )?.modulo || "No encontrado"}
              </label>
            </div>

            <h4 className="section-title-form">ESTADO</h4>
            <hr className="section-divider-form" />
            <div className="form-group-form">
              <label>
                {selectedItemToggle?.alternative.flagActive === 1
                  ? "Activo"
                  : "Inactivo"}
              </label>
            </div>

            <h4 className="section-title-form">PAQUETE</h4>
            <hr className="section-divider-form" />
            <div className="form-group-form">
              <label>
                {selectedItemToggle?.general.isPack === 1 ? "Sí" : "No"}
              </label>
            </div>
          </div>
        </SlideModal>
      </div>
    </div>
  );
};

export default ProductTypeList;
